import dayjs, { type Dayjs } from 'dayjs'

type Props = {
  date: Dayjs
}

export const ResourceHeader = ({ date }: Props) => {
  return <>{dayjs(date).format('ddd MM/DD')}</>
}
